import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

const startLeft = 70; // 40
const paddingWidth = 330; // 120
// const paddingPopoverWidth = 27;
// const startPopoverLeft = 125;
// const eventBlock = [
//   { default: false, title: '2015初 進駐香港', date: '2015-01-31', 'image': 'http://fakeimg.pl/300x225', text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Labore, cumque illo tempore, vel, quibusdam, ad nihil totam voluptatem reprehenderit voluptatum fuga eos quas nulla quaerat doloribus ipsum. Assumenda, odio atque.' },
//   { default: true, title: '2015中 進駐香港', date: '2015-08-31', 'image': 'http://fakeimg.pl/300x225', text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Labore, cumque illo tempore, vel, quibusdam, ad nihil totam voluptatem reprehenderit voluptatum fuga eos quas nulla quaerat doloribus ipsum. Assumenda, odio atque.' },
//   { default: false, title: '2016初 進駐香港', date: '2016-01-31', 'image': 'http://fakeimg.pl/300x225', text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Labore, cumque illo tempore, vel, quibusdam, ad nihil totam voluptatem reprehenderit voluptatum fuga eos quas nulla quaerat doloribus ipsum. Assumenda, odio atque.' },
//   { default: true, title: '2016中 進駐香港', date: '2016-08-31', 'image': 'http://fakeimg.pl/300x225', text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Labore, cumque illo tempore, vel, quibusdam, ad nihil totam voluptatem reprehenderit voluptatum fuga eos quas nulla quaerat doloribus ipsum. Assumenda, odio atque.' },
//   { default: false, title: '2017初 進駐香港', date: '2017-01-31', 'image': 'http://fakeimg.pl/300x225', text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Labore, cumque illo tempore, vel, quibusdam, ad nihil totam voluptatem reprehenderit voluptatum fuga eos quas nulla quaerat doloribus ipsum. Assumenda, odio atque.' },
//   { default: false, title: '2017中 進駐香港', date: '2017-08-31', 'image': 'http://fakeimg.pl/300x225', text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Labore, cumque illo tempore, vel, quibusdam, ad nihil totam voluptatem reprehenderit voluptatum fuga eos quas nulla quaerat doloribus ipsum. Assumenda, odio atque.' },
//   { default: true, title: '2017末 進駐香港', date: '2017-12-31', 'image': 'http://fakeimg.pl/300x225', text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Labore, cumque illo tempore, vel, quibusdam, ad nihil totam voluptatem reprehenderit voluptatum fuga eos quas nulla quaerat doloribus ipsum. Assumenda, odio atque.' },
// ];

let yearBlock;
let lineWidth;

class EventsBlock extends React.PureComponent {
  constructor({ news }) {
    super();

    yearBlock = news.reduce((result, event) => {
      const year = event.date.substr(0, 4);
      result[year] = result[year] || 0;
      result[year] += 1;
      return result;
    }, {});

    lineWidth = (startLeft * 2) + ((Object.keys(yearBlock).length + 1) * paddingWidth);

    this.state = {
      selectIndex: 2,
      startLeft: 70, // 40 , 0.0875
      paddingWidth: 330, // 120 // 0.4125
      paddingPopoverWidth: 27,
      startPopoverLeft: 125,
      lineWidth: 0,
    };
  }
  componentDidMount() {
    window.addEventListener('resize', () => {
      const startPopoverLeft = this.popoverBlock && document.querySelector('.popover.false') ? (
        this.popoverBlock.clientWidth -
        document.querySelector('.popover.false').clientWidth
      ) / 2 : 0;

      if (this.lineBlock && this.lineBlock.clientWidth) {
        this.setState({
          startLeft: this.lineBlock.clientWidth * 0.0875,
          paddingWidth: this.lineBlock.clientWidth * 0.4125,
          startPopoverLeft,
          // popoverWidth: this.popoverBlock.clientWidth * 0.736067298
        });
      }
    });
    window.dispatchEvent(new Event('resize'));
  }
  handleClickYear = (year) => {
    this.setState({
      selectIndex: this.props.news.findIndex(e =>
        e.date.substr(0, 4) === year && e.default
      )
    });
  }
  changeSelectIndex = (index) => {
    index = index < 0 ? 0 : index;
    index = index > this.props.news.length - 1 ? this.props.news.length - 1 : index;
    this.setState({
      selectIndex: index,
    });
  }
  render() {
    const {
      selectIndex,
      startPopoverLeft,
      paddingPopoverWidth,
    } = this.state;
    const { news, locale } = this.props;
    const chooseEvent = news.find((e, i) => i === selectIndex);
    const yearIndex = Object.keys(yearBlock).findIndex(y =>
      chooseEvent.date.substr(0, 4) === y
    );
    return (
      <div className="block events" id="events">
        <div className="container">
          <div className="title">
            {this.props.tt.events.title}
          </div>
          <div className="year-block">
            <div className="line-block" ref={dom => this.lineBlock = dom}>
              <div className="line" style={{ width: lineWidth }}>
                {Object.keys(yearBlock).map((year, i) =>
                  (<div
                    key={year}
                    data-year={year}
                    className={`
                      year
                      ${i === yearIndex && 'selected'}
                    `}
                    style={{
                      left:
                        this.state.startLeft + (this.state.paddingWidth * (i + (1 - yearIndex)))
                    }}
                    onClick={() => this.handleClickYear(year)}
                  />)
                )}
              </div>
            </div>
          </div>
          <div className="popover-block" ref={dom => this.popoverBlock = dom}>
            {Object.keys(yearBlock).map((year, i) => {
              const event = yearIndex === i ?
                news[selectIndex] :
                news.find(e => e.default && e.date.substr(0, 4) === year);
              return (
                <div
                  key={`p${year}`}
                  className={`popover ${yearIndex !== i && 'smaller'}`}
                  style={{
                    left: startPopoverLeft + ((paddingPopoverWidth + 700) * (i - yearIndex))
                  }}
                >
                  {
                    selectIndex > 0 &&
                    <button
                      className="prev material-icons"
                      onClick={() =>
                        this.changeSelectIndex(selectIndex - 1)
                      }
                    >
                      keyboard_arrow_left
                    </button>
                  }
                  {
                    selectIndex + 1 < news.length &&
                    <button
                      className="next material-icons"
                      onClick={() =>
                        this.changeSelectIndex(selectIndex + 1)
                      }
                    >
                      keyboard_arrow_right
                    </button>
                  }
                  <div
                    className="title"
                    dangerouslySetInnerHTML={{ __html: event.title }}
                  />
                  <div className="date">{event.date}</div>
                  <div
                    className="img"
                    style={{
                      backgroundImage: `url(${event.image})`
                    }}
                  />
                  <div className="text">{event.intro}</div>
                  <Link className="more" to={`${locale ? `/${locale}` : ''}/news/${event.date}`}>more &gt;</Link>
                </div>);
            })}
          </div>
        </div>
      </div>
    );
  }
}

EventsBlock.propTypes = {
  tt: PropTypes.object,
  news: PropTypes.array,
  locale: PropTypes.string,
};

EventsBlock.defaultProps = {
  tt: {},
  news: {},
  locale: '',
};

export default EventsBlock;



// WEBPACK FOOTER //
// ./src/HomePage/blocks/EventsBlock/index.js